import type { AdSettingEntryWithName, AdSettingsApiEntry } from '../api';
import { getAdSettingPages } from './adSettingsPages';

function adSettingsMapper(
  input: Record<string, AdSettingsApiEntry>,
): AdSettingEntryWithName[] {
  return Object.entries(input).map(([key, value]) => ({
    name: key,
    pages: getAdSettingPages(value),
    texts: value.texts ?? [],
  }));
}

export default adSettingsMapper;